import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { Card, CardBody, CardText, CardTitle, Col } from 'reactstrap'
import logoDark from "../../assets/images/holcimlogoAdipi.png";
import { PdfModal } from './PdfModal';

export const NormCard = ({ data, props }) => {

    // console.log('data card: ', data);

    const [file, setFile] = useState();

    useEffect(() => {
        
        setFile(data.file.replace('/usr/src/app/static/uploads/', ''));
     
    }, [data])
    

    const [showModalPDF, setShowModalPDF] = useState(false);

    const handleSelect = () => {
        // console.log('Se dio clic en un card 10');
        setShowModalPDF(true);
    }

    // const onClickCard = () => {
    //     localStorage.setItem("finalPath", JSON.stringify(data.file));
    //   }

    return (
        <>
            {/* {
                showModalPDF
                    ? <PdfModal props={props} setShowModal={setShowModalPDF} showModal={showModalPDF} rowInfo={} />
                    : ''
            } */}
            <Col className='px-2' xs='12' sm='12' md='4' lg='4' xl='3' xxl='2'>

                {/* <div className='px-2' > */}
                <Link to={{
                    pathname: `/normLibrary/PDF-Viewer/${file}`,
                }}
                >

                    <Card
                        className="rounded-3"
                        color="success"
                        outline
                    // inverse
                    // style={{
                    //     width: '100%',
                    //     cursor: 'pointer',
                    // }}
                    // onClick={handleSelect}
                    >

                        <CardBody>

                            <CardTitle>
                                <div className='text-center pb-3'>
                                    <img src={logoDark} alt="" height="25" />
                                </div>
                            </CardTitle>

                            <div className='row d-flex justify-content-center'><label className='text-center justify-content-center' style={{ cursor: 'pointer' }} >{data.norm.name}</label></div>

                            <hr className='text-info mb-2' />

                            <CardText>
                                <div className='row justify-content-center'><label className='text-center justify-content-center' style={{ cursor: 'pointer' }} >Contraseña:</label></div>
                                <div className='row d-flex justify-content-center'><label className='text-center justify-content-center' style={{ cursor: 'pointer' }} >{data.password}</label></div>
                            </CardText>

                        </CardBody>

                    </Card>

                </Link>

                {/* </div> */}

            </Col>

        </>
    )
}
